/**
 * Query param that tells {@link SendEventButton} to open the modal immediately on
 * mount instead of requiring a click — lets a deep link (e.g. the "Send Event"
 * Spotlight Search result, see `useSpotlightSearchRoutes.tsx`) land on Recent
 * Activity with the modal already open. Cleared from the URL once handled.
 *
 * Kept in its own file (no other imports) so callers that only need the param
 * name — like the globally-mounted Spotlight Search route registry — don't pull
 * in `SendEventModal`'s heavier dependencies (CodeMirror, the GraphQL mutation, etc.).
 */
export const SEND_EVENT_QUERY_PARAM = "sendEvent";
